import {
    useMemo,
} from 'react'

import EngagementForm from 'app/Apps/RelationshipsManagement/Engagement/EngagementForm'
import {
    EngagementType,
} from 'app/Apps/RelationshipsManagement/Engagement/engagement.types'
import {
    ArchiveButton, useArchive, ArchiveConfirmationDialog,
} from 'app/shared-components/Archive'
import request from 'app/requests/Engagement.requests'

export default function EngagementDemoEditForm({
    data,
    onSuccess,
    onCancel,
    backPath = undefined,
}: Readonly<{
    data: EngagementType,
    onSuccess: () => void,
    onCancel: () => void,
    backPath?: string,
}>) {
    const archive = useArchive({
        requestParamFn: data?.archived ? request.restore
            : request.archive,
        notificationId: 'EngagementUpdate',
        title: 'Engagement',
        data,
        redirectionAfterSuccess: backPath,
    })

    const customButtons = useMemo(() => {
        return [<ArchiveButton
            onClick={archive.handleArchiveRestore}
            archived={data?.archived}
        />]
    }, [
        archive,
        data?.archived,
    ])

    return (
        <>
            <EngagementForm
                requestParam={request.update({
                    id: data.id,
                })}
                data={data as EngagementType}
                onSuccess={onSuccess}
                onCancel={onCancel}
                customButtons={customButtons}
            />
            <ArchiveConfirmationDialog
                title="Engagement"
                openConfirmDialog={archive.openConfirmDialog}
                handleClose={archive.handleArchiveRestoreConfirm}
                archived={data?.archived}
            />
        </>
    )
}
